function addValueToObject(obj: any, key: any, value: any) {
  if (obj.hasOwnProperty(key)) {
    obj[key].commission.push(value);
  } else {
    console.log("Key does not exist in the object.");
  }
}

export { addValueToObject };
